import React from 'react';
import { ArrowLeftIcon, CheckCircleIcon } from '@heroicons/react/24/outline';

const ConfirmationScreen = ({ registrationData, onConfirm, onBack }) => {
  const { selectedProvince, selectedClub, seasonYear } = registrationData;

  return (
    <div className="max-w-4xl mx-auto">
      <div className="bg-gray-800 rounded-xl p-8 shadow-2xl">
        {/* Header with back button */}
        <div className="flex items-center mb-8">
          <button
            onClick={onBack}
            className="flex items-center text-gray-400 hover:text-white mr-4 transition-colors"
          >
            <ArrowLeftIcon className="h-5 w-5 mr-2" />
            Back
          </button>
          <div className="flex-1">
            <h1 className="text-3xl font-bold text-white mb-2">Confirm Registration</h1>
            <p className="text-gray-400">Please review your registration details before proceeding to payment</p>
          </div>
        </div>

        {/* Registration Details */}
        <div className="bg-gray-700 rounded-lg p-6 mb-8">
          <div className="flex items-center mb-6">
            <CheckCircleIcon className="h-8 w-8 text-green-500 mr-3" />
            <h2 className="text-2xl font-bold text-white">Registration Summary</h2>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {/* Club Information */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-red-400 mb-4">Club Details</h3>
              <div className="flex items-center space-x-4">
                {selectedClub?.logo ? (
                  <img 
                    src={selectedClub.logo} 
                    alt={selectedClub.name} 
                    className="w-16 h-16 object-cover rounded-full border-2 border-gray-600"
                  />
                ) : (
                  <div className="w-16 h-16 bg-gray-600 rounded-full flex items-center justify-center">
                    <span className="text-gray-400 text-xl font-bold">
                      {selectedClub?.name?.charAt(0) || 'C'}
                    </span>
                  </div>
                )}
                <div>
                  <h4 className="text-xl font-bold text-white">{selectedClub?.name}</h4>
                  {selectedClub?.location && (
                    <p className="text-gray-300">{selectedClub.location}</p>
                  )}
                  {selectedClub?.foundedYear && (
                    <p className="text-gray-400 text-sm">Founded: {selectedClub.foundedYear}</p>
                  )}
                </div>
              </div>
            </div>

            {/* Province/League Information */}
            <div className="space-y-4">
              <h3 className="text-lg font-semibold text-red-400 mb-4">League Details</h3>
              <div className="space-y-3">
                <div>
                  <span className="text-gray-400">Province/League:</span>
                  <p className="text-white font-semibold">{selectedProvince?.name}</p>
                </div>
                <div>
                  <span className="text-gray-400">Season Year:</span>
                  <p className="text-white font-semibold">{seasonYear}</p>
                </div>
                <div>
                  <span className="text-gray-400">Registration Fee:</span>
                  <p className="text-white font-semibold">K{selectedProvince?.registrationFee || 210.00}</p>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Important Information */}
        <div className="bg-blue-900/20 border border-blue-500/30 rounded-lg p-6 mb-8">
          <h3 className="text-lg font-semibold text-blue-400 mb-3">Important Information</h3>
          <ul className="text-gray-300 space-y-2">
            <li className="flex items-start">
              <span className="text-blue-400 mr-2">•</span>
              Registration is valid for the entire {seasonYear} season
            </li>
            <li className="flex items-start">
              <span className="text-blue-400 mr-2">•</span>
              Payment must be completed to confirm your registration
            </li>
            <li className="flex items-start">
              <span className="text-blue-400 mr-2">•</span>
              You will receive a confirmation email after successful payment
            </li>
            <li className="flex items-start">
              <span className="text-blue-400 mr-2">•</span>
              Registration fees are non-refundable
            </li>
          </ul>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-between items-center">
          <button
            onClick={onBack}
            className="px-8 py-3 bg-gray-600 hover:bg-gray-500 text-white rounded-lg transition-colors"
          >
            Back to Club Selection
          </button>
          <button
            onClick={onConfirm}
            className="px-8 py-3 bg-red-600 hover:bg-red-700 text-white rounded-lg font-semibold transition-colors"
          >
            Proceed to Payment
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmationScreen; 